<template>
    <div style="height: 100%" v-show="value">
      <v-row align="center" justify="center" style="height: 100%;">
        <v-col>
          <spinner-cadu
            :line-fg-color="$vuetify.theme.themes.light.primary1"
            :size="100"
            :line-size="5"
            :speed="0.6"
            :font-size="30"
            :spacing="10"
            :text-fg-color="$vuetify.theme.themes.light.fontColor"
            message="Carregando"
          />
        </v-col>
      </v-row>
    </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: true
    }
  }
}
</script>
